module.exports = __webpack_public_path__ + "assets/click.b54d1c19.svg";